import React from 'react';

const Service = ({translate, className, label, text, icon}) => (
	<div className={className}>
		<div className="single-services text-center card hoverable">
			<div className="card-content">
				<div className="service-icon">
					<i className={`mdi mdi-${icon}`}/>
				</div>
				<h4>{translate(label)}</h4>
				<p className="text-justify">{translate(text)}</p>
			</div>
		</div>
	</div>
);

export default Service;



// WEBPACK FOOTER //
// ./src/components/elements/Service.js